import {RawEditorSettings} from "tinymce";
import { SettingsModel } from "@rdv-lib";

const tinymceSettings: RawEditorSettings = {
  height: 400,
  skin: 'oxide-dark',
  plugins: 'print preview paste importcss searchreplace autolink autosave save ' +
  'directionality code visualblocks visualchars fullscreen image link media template ' +
  'codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime ' +
  'advlist lists wordcount imagetools textpattern noneditable help charmap quickbars ' +
  'emoticons',
  menubar: 'file edit view insert format tools table help',
  toolbar: 'undo redo | bold italic underline strikethrough ' +
  '| fontselect fontsizeselect formatselect ' +
  '| alignleft aligncenter alignright alignjustify ' +
  '| outdent indent ' +
  '|  numlist bullist ' +
  '| forecolor backcolor removeformat ' +
  '| pagebreak ' +
  '| charmap emoticons ' +
  '| fullscreen  preview save print ' +
  '| insertfile image media template link anchor codesample ' +
  '| ltr rtl',
};

export const richtextEditor: Partial<SettingsModel> = {
  richtextEditor: tinymceSettings
};
